// 混入通用状态映射
export default {
  data () {
    return {
      statusMap: {
        Available: { text: '可用', color: 'blue' },
        Disabled: { text: '不可用', color: 'grey' }
      },
      genderMap: {
        M: { text: '男', color: 'blue' },
        F: { text: '女', color: 'red' },
        U: { text: '保密', color: 'grey' }
      },
      superManagerMap: {
        true: { text: '超级管理', color: 'orange' },
        false: { text: '普通管理', color: 'green' }
      },
      tradeStatusMap: {
        Pending: { text: '待支付', color: 'orange' },
        Paid: { text: '已支付', color: 'blue' },
        Canceled: { text: '已取消', color: 'grey' }
      },
      logCategoryMap: {
        Access: { text: '浏览', color: 'green' },
        DownImagePack: { text: '下载图包', color: 'blue' }
      },
      sourceMap: {
        System: { text: '系统', color: 'blue' },
        Refund: { text: '退款', color: 'orange' },
        Paid: { text: '抵扣支付', color: 'grey' }
      },
      filterCategoryMap: {
        Color: { text: '色系', color: 'blue' },
        Material: { text: '材质', color: 'orange' },
        Texture: { text: '纹理', color: 'red' }
      },
      stoneSpecCategoryMap: {
        FifteenMulFifteen: { text: '15×7', color: 'blue' },
        FifteenMulSeven: { text: '15×15', color: 'green' }
      }
    }
  },

  methods: {
    // 获取标签
    getStatusTag (v) {
      const t = this.statusMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    },
    getGenderTag (v) {
      const t = this.genderMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    },
    getManagerTypeTag (v) {
      const t = this.superManagerMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    },
    getTradeStatusTag (v) {
      const t = this.tradeStatusMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    },
    getLogCategoryTag (v) {
      const t = this.logCategoryMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    },
    getSourceMap (v) {
      const t = this.sourceMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    },
    getFilterMap (v) {
      const t = this.sourceMap[v]
      if (t) return <a-tag color={t.color}>{t.text}</a-tag>
      return <a-tag color='grey'>/</a-tag>
    }
  }
}
